import { Component } from '@angular/core';

@Component({
	selector: 'app-svg-spinner',
	templateUrl: './svg-spinner.component.html',
	styleUrls: ['./svg-spinner.component.scss'],
})
export class SvgSpinnerComponent {}
